import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import kit from "../../images/kitchen/kit.png";
const DiscountSection = () => {
  return (
    <Container className="my-5">
      {/* //discount-backcolor  */}
      <Row className="my-3 mx-2 d-flex text-center align-items-center bg-white shadow rounded flex-column-reverse flex-sm-row pb-3 p-sm-0">
        <Col sm="6">
          <div className="discount-title text-dark">خصم يصل حتي ٣٠٪</div>
        </Col>
        <Col sm="6">
          <img className="dicount-img" src={kit} alt="" />
        </Col>
      </Row>
    </Container>
  );
};

export default DiscountSection;
